module.exports = __webpack_public_path__ + "static/media/grataCanisMajor.5aa1a1a5.jpg";